<template>
  <div class="mini-hub mini-loader">
    <div class="mb-4">
      <PuSkeleton height="2rem"></PuSkeleton>
    </div>

    <PuSkeleton :count="3"></PuSkeleton>
  </div>
</template>

<script>
import Skeleton from "vue-loading-skeleton";
import Vue from "vue";

Vue.use(Skeleton);

export default {
  name: "Loader",
};
</script>
